import React from 'react';
import styled from 'styled-components';

type ShimmerProps = {
  rows?: number;
  columns?: number;
  rowHeight?: string;
};

const Row = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const Cell = styled.div<{ $height: string }>`
  flex: 1;
  height: ${({ $height }) => $height};
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(32, 32, 32, 0.9), rgba(24, 24, 24, 0.9));
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.12), transparent);
    animation: shimmerSweep 1.1s var(--transition-smooth) infinite;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Shimmer: React.FC<ShimmerProps> = ({ rows = 5, columns = 4, rowHeight = '1.25rem' }) => {
  return (
    <Wrapper aria-hidden="true">
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <Row key={`shimmer-row-${rowIdx}`}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Cell key={`shimmer-cell-${rowIdx}-${colIdx}`} $height={rowHeight} />
          ))}
        </Row>
      ))}
    </Wrapper>
  );
};

